export default __webpack_public_path__ + "static/media/login.756cbb71.svg";